import React from 'react';
import ScrollAwareFormSelect from '../shared/ScrollAwareFormSelect';

export default function SelectEntityElement({
  scrollContextRef,
  onChange,
  options,
  label,
  placeholder,
  value,
  error,
  upward,
  disabled,
  multiple
}) {
  return (
    <ScrollAwareFormSelect
      scrollContextRef={scrollContextRef}
      search
      clearable
      label={label}
      placeholder={placeholder}
      value={value}
      error={error}
      upward={upward}
      disabled={disabled}
      options={options}
      multiple={multiple}
      onChange={(event, { value }) => onChange(value || null)} />
  );
}